import { useShallow } from "zustand/react/shallow";

import type { CartItem } from "~/providers/cart-provider";
import { useCartTable } from "~/hooks/use-cart-table";
import { useCartStore } from "~/stores/use-cart-store";
import { useOrderStore } from "~/stores/use-order-store";
import ItemsTable from "../cash-register/items-table";

export default function OrderTransferForm() {
  const { items } = useCartStore(
    useShallow((state) => ({
      items: state.items,
    })),
  );

  const { addTransferItem, transferItems, removeTransferItem } =
    useOrderStore();

  const handleSelect = (item: CartItem) => {
    if (item.parentReference) {
      return;
    }
    const children = items.filter((i) => i.parentReference === item.reference);
    if (transferItems.some((i) => i.reference === item.reference)) {
      removeTransferItem(item);
      // also remove all the children

      children.forEach((child) => {
        removeTransferItem(child);
      });
    } else {
      addTransferItem(item);
      // also add all the children

      children.forEach((child) => {
        addTransferItem(child);
      });
    }
  };

  const { columns } = useCartTable({
    canSelect: true,
    items: transferItems,
    onSelect: handleSelect,
  });

  return <ItemsTable items={items} onSelect={handleSelect} columns={columns} />;
}
